import { orderActionTypes } from '../order-action-types';
import axios from 'axios';
import { BASE_URL } from '../../../../config/environmentConfig';
import { sendSentryMessage } from '../../../utils/sentry-helper';
import { getFormattedFormFields, IActivityLogReturnTypes } from '../../../constants/activity-log/activity-log-form';
import { errorHandler } from '../../../utils/newApplicationUtils';
import { IActivityLogsParams } from '../../merchnts/merchant-interfaces';
import * as React from 'react';
import { IOrderAction } from '../order-interfaces';
import { MRT_PaginationState } from 'material-react-table';
import { getEndDate } from './order-context-helper';
import { makeSearchParams } from '../../../utils/utilities';

export const fetchOrderActivityLists = async (dispatch: React.Dispatch<IOrderAction>): Promise<void> => {
	dispatch({ type: orderActionTypes.SET_ORDER_ACTIVITY_LOG_LISTS_LOADING, payload: true });
	try {
		const lists = await axios
			.get(`${BASE_URL.ACTIVITY}/lists`)
			.then(res => {
				let activityCategories = [];
				let informationLevels = [];

				if (res?.data?.activityCategories) {
					activityCategories = Object.entries(res.data.activityCategories || {})?.map(([key, value]) => ({
						value: key,
						label: value
					}));
				}

				if (res?.data?.informationLevels) {
					informationLevels = Object.entries(res.data.informationLevels || {})?.map(([key, value]) => ({
						value: Number(key),
						label: value
					}));
				}
				return {
					activityCategories,
					informationLevels
				};

			});
		dispatch({ type: orderActionTypes.FETCH_ORDER_ACTIVITY_LOG_LISTS, payload: lists });
	} catch (error) {
		console.log('fetchOrderActivityLists error', error);
		sendSentryMessage({ name: `GET Fetch search filter list error`, context: error });
		dispatch({ type: orderActionTypes.SET_ORDER_ACTIVITY_LOG_LISTS_LOADING, payload: false });
	}
};

export const setActivityLogFilters = (data: IActivityLogReturnTypes): { [p: string]: string | string[] } => {
	const params: { [key: string]: string | string[] } = {};
	if (data?.search) {
		params.search = data.search;
	}
	if (data?.category?.length) {
		params.category = data.category;
	}
	if (data?.infoLevel?.length) {
		params.infolevel = data.infoLevel;
	}
	return params;
};

export const fetchOrderActivityLogData = async (dispatch: React.Dispatch<IOrderAction>, id: string, formik?: any): Promise<void> => {
	dispatch({ type: orderActionTypes.SET_ORDER_ACTIVITY_LOG_DATA_LOADING, payload: true });
	try {
		const formattedData = formik ? getFormattedFormFields(formik.values) : {};
		const params = setActivityLogFilters(formattedData);

		const res = await axios.get(`${BASE_URL.ACTIVITY}/Activities/${id}/activityLog`, {
			params,
			paramsSerializer: params => makeSearchParams(params)
		});
		dispatch({
			type: orderActionTypes.FETCH_ORDER_ACTIVITY_LOG_DATA,
			payload: {
				data: res?.data?.activities || [],
				enableArchiveSearch: res?.data?.enableArchiveSearch,
			}
		});
	} catch (error) {
		console.log('fetchOrderActivityLogData error', error);
		sendSentryMessage({ name: `GET Fetch activity list error`, context: error });
		dispatch({ type: orderActionTypes.SET_ORDER_ACTIVITY_LOG_DATA_LOADING, payload: false });
		if (formik) {
			errorHandler({ e: error, formik });
		}
	}
};

export const fetchArchivedOrderActivityLogData = async (dispatch: React.Dispatch<IOrderAction>, id: string, createdOn: Date): Promise<void> => {
	try {

		const from = new Date(createdOn).toISOString().split('T')[0];
		const oneMonthLater = getEndDate(createdOn);
		const to = oneMonthLater.toISOString().split('T')[0];
		const res = await axios.get(`${BASE_URL.ACTIVITY}/Activities/${id}/activityLog-archive?from=${from}&to=${to}`);

		dispatch({
			type: orderActionTypes.FETCH_ORDER_ACTIVITY_LOG_DATA,
			payload: {
				data: res?.data || [],
				enableArchiveSearch: false,
			}
		});
	} catch (e) {
		console.log('fetchArchivedOrderActivityLogData error', e);
		dispatch({ type: orderActionTypes.SET_ORDER_ACTIVITY_LOG_DATA_LOADING, payload: false });
	}
};

export const fetchActivityLogList = async (
	dispatch: React.Dispatch<IOrderAction>,
	activityLogTablePageNumber: number,
	activityLogTablePageSize: number,
	chosenMerchant: string,
	debouncedTenantId: string,
	debouncedCorrelationId: string
): Promise<void> => {
	dispatch({ type: orderActionTypes.SET_ACTIVITY_LOG_LIST_LOADING, payload: true });
	try {
		const params: IActivityLogsParams = {
			pageNumber: activityLogTablePageNumber,
			pageSize: activityLogTablePageSize
		};
		if (chosenMerchant) {
			params.mid = chosenMerchant;
		}
		if (debouncedTenantId) {
			params.mid = debouncedTenantId;
		}
		if (debouncedCorrelationId) {
			params.orderId = debouncedCorrelationId;
		}
		const res = await axios.get(`${BASE_URL.ACTIVITY}/Activities`, { params });
		dispatch({ type: orderActionTypes.FETCH_ACTIVITY_LOG_LISTS, payload: res?.data?.rows ?? [], totalItemCount: res?.data?.totalItemCount });
	} catch (e) {
		sendSentryMessage({ name: `GET Fetch activities error`, context: e });
		console.log(e);
		dispatch({ type: orderActionTypes.FETCH_ACTIVITY_LISTS_FAIL });
	}
};

export const setActivityLogPagination = (dispatch: React.Dispatch<IOrderAction>, value: MRT_PaginationState): void => {
	dispatch({
		type: orderActionTypes.SET_ACTIVITY_LOG_TABLE_PAGINATION,
		payload: {
			pageNumber: value.pageIndex,
			pageSize: value.pageSize
		}
	});
};
